module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "subtitle"
  }, [_vm._v("THE ONLY "), _c('br'), _vm._v("BUDGETING "), _c('br'), _vm._v("BOOK"), _c('br'), _vm._v("YOU’LL EVER "), _c('br'), _vm._v("NEED")]), _vm._v(" "), _c('h1', {
    staticClass: "subtitle1"
  }, [_vm._v("How to Save Money and Manage "), _c('br'), _vm._v("Your Finances with a Personal "), _c('br'), _vm._v("Budget Plan That Works for You")]), _vm._v(" "), _c('h1', {
    staticClass: "subtitle2"
  }, [_vm._v("TERE STOUFFER")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/logo.gif"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c2e9b09e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/tp.vue
// module id = 63
// module chunks = 0